import { formatDayjs } from "../../../services/localeFormat"
import React from "react"

import {Card, Col, Divider, Spin, Typography} from "antd";

import ApiService from "../../../services/ApiService"

import {ASSET_URL} from "../../../config";
import InfiniteScroll from "react-infinite-scroll-component";
import Link from "next/link";
import {Trans} from "@lingui/react/macro"
import dayjs from "dayjs";
import logger from "../../../services/logger"

const {Text}=Typography

export default class ListRender extends React.Component{

    state = {
        data: [],
        loading: false,
        page:0,
        finished:false,
    };

    componentDidMount() {
        this.setState({loading:true},()=>{
            this.getData(true)
        })
    }

    async getData(init=false)
    {
        const context=this.props.context
        const {org}=context

        var page=this.state.page+1
        if(init){
            page=1
        }

        this.setState({ loading: true });
        var res=await ApiService.post("/galeries/"+org.id,{page:page})
        logger.debug({ res }, "res")

        var finished=true
        if(res.data.length>0){
            finished=false
        }

        var finalData=[...this.state.data,...res.data]
        if(init){
            finalData=res.data
        }

        this.setState({
            loading: false,
            data: finalData,
            page:page,
            finished:finished
        });
    };


    render()
    {
        const context=this.props.context
        const {org}=context

        return(
          <div style={{padding:"50px 0"}}>


              {!this.state.loading && this.state.data.length==0 &&(
                  <div style={{marginTop:50,display:"flex",alignItems:"center",justifyContent:"center"}}>
                      <span><Trans>Cet organisme n'a pas encore de galerie.</Trans></span>
                  </div>
              )}

              <div className={`my-4 container-fluid`}>
                      <InfiniteScroll
                          dataLength={this.state.data.length} //This is important field to render the next data
                          next={()=>this.getData()}
                          hasMore={!this.state.finished}
                          loader={<div style={{display:"flex",alignItems:"center",justifyContent:"center",width:"100%"}}><Spin spinning/></div>}
                          style={{display:"flex",flexWrap:"wrap",gap:30,overflow:"visible"}}
                          scrollableTarget={"main"}
                      >
                          {this.state.data.map(item => {

                              return (
                                  <Link href={org.BASE_WEB_URL+"/galerie/"+item.id}>
                                      <Col key={item.id}>
                                          <Card
                                              hoverable
                                              style={{width:300}}
                                              cover={<img src={ASSET_URL+"/"+item.bgImage} style={{height:250,width:300,objectFit:"cover",objectPosition:"top"}} />}
                                          >


                                              <Card.Meta
                                                  title={item.name}
                                                  description={item.description}
                                              />

                                              <Divider/>
                                              <Col><Text type="secondary"><Trans>Créer le {formatDayjs(item.datetime, context.langValue, "dddd DD MMMM YYYY")}</Trans></Text></Col>
                                          </Card>

                                      </Col>
                                  </Link>
                              )
                          })}
                      </InfiniteScroll>
                  </div>
          </div>
        )
    }
}

/*

*/
